import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TranslatorManager from 'ts-translate-js';

const tr = TranslatorManager.boundTR;

// This is just the control to put when you have no items...
export class NoItem extends Component {   
    constructor(props) {
        super(props);
    }

    render () {
        return (
            <div className="no-item">{this.props.noitemLabel ? this.props.noitemLabel : tr('tsadminreactcontrols.noitem', { fallback: 'Aucun' })}</div>
        );
    }
}

NoItem.propTypes = {
    noitemLabel: PropTypes.string
};

export class ProcessingItem extends Component {
    constructor(props) {
        super(props);
    }

    render () {
        return (
            <div className="processing-item"><img className="icon" alt="" /><span className="label">{tr('tsadminreactcontrols.processing')}</span></div>
            
        );
    }
}

export function SmallestProcessingItem() {
    return <div className="processing-item smallest"><img className="icon" alt="" /></div>;
}
